module.exports = __webpack_public_path__ + "static/img/08046A_1_R_20200821_LC.47e24cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08046A_1_R_20200821_LC.png
// module id = /tKR
// module chunks = 0